import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consent-header',
  imports: [],
  templateUrl: './consent-header.component.html',
  styleUrl: './consent-header.component.scss',
  standalone: false
})
export class ConsentHeaderComponent implements OnInit {
  ngOnInit(): void {
  }

}
